<template>
  <el-dialog
    :title="modalTitle"
    :visible.sync="showDialog"
    width="716px"
    :close-on-click-modal="false"
  >
    <div class="modal-wrap">
      <el-select
        v-model="curPro"
        placeholder="请选择"
        style="margin-bottom: 10px; width: 160px"
      >
        <el-option label="今日头条" value="jrtt"></el-option>
        <el-option label="广点通" disabled value="gdt"></el-option>
      </el-select>
      <div class="table-wrap" style="min-height: 400px">
        <el-table :data="tableData" style="width: 100%" height="379">
          <el-table-column
            align="center"
            prop="advertiserId"
            label="广告账户ID"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="advertiserName"
            label="广告账户名称"
          >
          </el-table-column>
        </el-table>
      </div>
      <self-pagination
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        @getCurrentPage="getCurrentPage"
        @handleSizeChange="changePageSize"
        ref="tabelPagination"
      ></self-pagination>
    </div>
  </el-dialog>
</template>

<script>
import produceServer from "@/api/product.js";
import userServer from "@/api/userManagement.js";
export default {
  props: {},
  data() {
    return {
      showDialog: false,
      modalTitle: "",
      curPro: "jrtt",
      tableData: [],
      pageData: {
        size: 10,
        page: 1,
        total: 0,
      },
      curType: null, //当前查询类型（product, user）
      curId: null, //当前的查询id
    };
  },
  methods: {
    showModal(data, title, type) {
      this.tableData = [];
      this.pageData.page = 1;
      this.modalTitle = title;
      this.curId = data.id;
      this.curType = type;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.tabelPagination.currentPage = 1;
        this.getListData();
      });
    },
    getListData() {
      if (this.curType === "product") {
        //产品管理
        let parmas = {
          productId: this.curId,
          size: this.pageData.size,
          page: this.pageData.page,
        };
        produceServer.queryProductPermission(parmas).then((res) => {
          if (res.code === "0000") {
            this.tableData = res.productPermissionList;
            this.pageData.total = res.totalCount;
          }
        });
      } else {
        //用户管理
        let parmas = {
          userId: this.curId,
          size: this.pageData.size,
          page: this.pageData.page,
        };
        userServer.queryUserPermission(parmas).then((res) => {
          if (res.code === "0000") {
            this.tableData = res.userPermissionList;
            this.pageData.total = res.totalCount;
          }
        });
      }
    },
    getCurrentPage(page) {
      this.pageData.page = page;
      this.getListData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getListData();
    },
  },
};
</script>

<style scoped>
.forLabel {
  margin-bottom: 10px;
}
</style>